import { RefinementCtx, z } from 'zod';

export const hasUpperCase = (str: string) =>
  /.*[A-ZÀÂÇÈÉÊËÎÏÔŒÙÛÜŸ].*/.test(str);

export const hasNumber = (str: string) => /.*[0-9].*/.test(str);

export const hasLower = (str: string) => /.*[a-zàâçèéêëîïôœùûüÿ].*/.test(str);

export const hasSpecialChar = (str: string) =>
  /[!@#$/&*()\-.+[\]:;,?=<>%_\\]/.test(str);

const hasValidCharacters = (str: string) => {
  const regex =
    /^[A-ZÀÂÇÈÉÊËÎÏÔŒÙÛÜŸa-zàâçèéêëîïôœùûüÿ0-9!@#$/&*()\-.+[\]:;,?=<>%_\\]+$/;
  return regex.test(str);
};

export const noConsecChar = (str: string) =>
  /^(?!.*(.)\1{2}).+$/.test(str.toLowerCase());

export const noConsecSequence = (str: string) =>
  !/(..)(.*?\1){2,}/.test(str.toLowerCase());

const requiredConstraints = (password: string) => {
  let satisfiedConstraints = 0;

  if (hasSpecialChar(password)) {
    satisfiedConstraints++;
  }

  if (hasUpperCase(password)) {
    satisfiedConstraints++;
  }

  if (hasNumber(password)) {
    satisfiedConstraints++;
  }

  if (hasLower(password)) {
    satisfiedConstraints++;
  }

  return satisfiedConstraints >= 4;
};

export const basePasswordFieldValidation = z
  .string()
  .min(8, 'error.minLength.8')
  .max(20, 'error.maxLength.20')
  .refine(requiredConstraints, 'passwordError.missingPasswordConstraints')
  .refine(
    (passwordFieldValue) => noConsecSequence(passwordFieldValue),
    'passwordError.hasConsecSequence',
  )
  .refine(
    (passwordFieldValue) => noConsecChar(passwordFieldValue),
    'passwordError.hasConsecChar',
  )
  .refine(
    (passwordFieldValue) => hasValidCharacters(passwordFieldValue),
    'error.invalidCharacters',
  );

export const addNoMatchingPasswordIssue = (
  ctx: RefinementCtx,
  path: string[],
) => {
  ctx.addIssue({
    code: 'custom',
    message: 'passwordError.noMatchingPassword',
    path,
  });
};
